import {
  ISearchRequest,
  ClientSearchSDK,
  ISearchResponse,
  ISearchResponseTotals,
  ISampleResponse,
  SearchDocumentType,
  ISampleResponseSample,
  IErrorResponse,
} from '@wix/client-search-sdk';

const SAMPLES_SIZE = {
  MOBILE: 4,
  DESKTOP: 3,
};

export function getSearchResponses(
  searchRequest: ISearchRequest,
  shouldShowSamples: boolean,
  searchSDK: ClientSearchSDK,
  isMobile: boolean,
  previousQuery: string | undefined,
  searchResponseTotals: ISearchResponseTotals,
) {
  const shouldLoadTotals = previousQuery !== searchRequest.query;

  const samplesPromise =
    shouldShowSamples || shouldLoadTotals
      ? searchSDK.getSample({
          query: searchRequest.query,
          limit: isMobile ? SAMPLES_SIZE.MOBILE : SAMPLES_SIZE.DESKTOP,
        })
      : Promise.resolve({ results: [] });

  return Promise.all<
    ISearchResponse | IErrorResponse,
    ISearchResponseTotals | IErrorResponse,
    ISampleResponse | IErrorResponse
  >([
    shouldShowSamples
      ? Promise.resolve({
          documents: [],
          documentType: SearchDocumentType.All,
          totalResults: 0,
        })
      : searchSDK.search(searchRequest),
    shouldLoadTotals
      ? samplesPromise.then(
          (samplesResponse: ISampleResponse | IErrorResponse) => {
            if ('isError' in samplesResponse) {
              return samplesResponse;
            }
            const totalResults = samplesResponse.results.reduce(
              (sum, { total }) => sum + total,
              0,
            );
            return samplesResponse.results.reduce(
              (
                totals: ISearchResponseTotals,
                { documentType, total }: ISampleResponseSample,
              ) => {
                totals[documentType] = total;
                return totals;
              },
              {
                [SearchDocumentType.All]: totalResults,
              },
            );
          },
        )
      : searchResponseTotals,
    samplesPromise,
  ]);
}
